import { render, staticRenderFns } from "./r-scale.vue?vue&type=template&id=32a17fff&scoped=true"
import script from "./r-scale.vue?vue&type=script&setup=true&lang=js"
export * from "./r-scale.vue?vue&type=script&setup=true&lang=js"
import style0 from "./r-scale.vue?vue&type=style&index=0&id=32a17fff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a17fff",
  null
  
)

export default component.exports